export function updateMarketStatusNew(state, marketStatusNew) {
  state.asOf = marketStatusNew.as_of;
  state.asOfLive = marketStatusNew.as_of_live;
  state.asOfWeekly = marketStatusNew.as_of_weekly;
  state.asOfHourly = marketStatusNew.as_of_hourly;
  state.marketStatus = marketStatusNew.is_open;
  state.isLtpVsCloseLive = Boolean(marketStatusNew.ltp);
}
